import { render, staticRenderFns } from "./TableExpandList.vue?vue&type=template&id=51e593ff&scoped=true&"
import script from "./TableExpandList.vue?vue&type=script&lang=ts&"
export * from "./TableExpandList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e593ff",
  null
  
)

export default component.exports